const replaceNullsWithEmptyString = (object) => Object.entries(object).reduce((acc, [key, value]) => {
  if (value === null) {
    return { ...acc, [key]: '' };
  }
  return acc;
}, object);

export default replaceNullsWithEmptyString;
